import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import {
  Contract,
  ContractSummary,
  ContractProgress,
  ContractProfitability,
  CreateContractRequest,
  UpdateContractRequest,
  Trip,
  Invoice,
} from '../types';

export const contractService = {
  getAll: async (): Promise<Contract[]> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<Contract> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.BY_ID(id));
    return response.data;
  },

  getByStatus: async (status: string): Promise<Contract[]> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.BY_STATUS(status));
    return response.data;
  },

  getSummary: async (): Promise<ContractSummary[]> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.SUMMARY);
    return response.data;
  },

  getProgress: async (id: number): Promise<ContractProgress> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.PROGRESS(id));
    return response.data;
  },

  getProfitability: async (id: number): Promise<ContractProfitability> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.PROFITABILITY(id));
    return response.data;
  },

  getTrips: async (id: number): Promise<Trip[]> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.TRIPS(id));
    return response.data;
  },

  getInvoices: async (id: number): Promise<Invoice[]> => {
    const response = await apiClient.get(API_ENDPOINTS.CONTRACTS.INVOICES(id));
    return response.data;
  },

  create: async (data: CreateContractRequest): Promise<Contract> => {
    const response = await apiClient.post(API_ENDPOINTS.CONTRACTS.BASE, data);
    return response.data;
  },

  update: async (id: number, data: UpdateContractRequest): Promise<Contract> => {
    const response = await apiClient.put(API_ENDPOINTS.CONTRACTS.BY_ID(id), data);
    return response.data;
  },

  approve: async (id: number): Promise<Contract> => {
    const response = await apiClient.post(API_ENDPOINTS.CONTRACTS.APPROVE(id));
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.CONTRACTS.BY_ID(id));
  },
};
